// extracted by mini-css-extract-plugin
module.exports = {"center":"jobNew_center__3tm87","hleperText":"jobNew_hleperText__2pRwd"};